export enum WarrantyStatus {
	InWarranty = 0,
	WarrantyExpired = 1,
	WarrantyNotFound = 2
}
